import React from 'react';
import './Amenidades.scss';
import Slider from '../Slider/Slider';
import { SwiperSlide } from "swiper/react";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";
import { useTranslation } from "react-i18next"; // Importa el hook

const Amenidades = () => {
  const { t } = useTranslation();

  return ( 
    <div id="amenidades" className='contenedor_amenidades'>
      <div className='amenidades_top'>
        <AnimationOnScroll
          duration={2}
          animateOnce={true}
          animateIn='animate__fadeIn'>
          <div className='subtitulo_ame'>
            <h2 dangerouslySetInnerHTML={{__html: t('amenities.title')}} />
          </div>
        </AnimationOnScroll>
        <div className='list_ame'>
          <div className='colum_list'>
            <img src="/assets/Iconos/Amenidades/svg-icon-caseta.svg" alt={t('amenities.accessControl')} />
            <p>{t('amenities.accessControl')}</p>
          </div>
          <div className='colum_list'>
            <img src="/assets/Iconos/Amenidades/svg-icon-juegos-infantiles.svg" alt={t('amenities.playground')} />
            <p>{t('amenities.playground')}</p>
          </div>
          <div className='colum_list'>
            <img src="/assets/Iconos/Amenidades/svg-icon-lineal.svg" alt={t('amenities.linearPark')} />
            <p>{t('amenities.linearPark')}</p>
          </div>
          <div className='colum_list'>
            <img src="/assets/Iconos/Amenidades/svg-icon-dogpark.svg" alt={t('amenities.dogPark')} />
            <p>{t('amenities.dogPark')}</p>
          </div>
          <div className='colum_list'>
            <img src="/assets/Iconos/Amenidades/svg-icon-ciclovia.svg" alt={t('amenities.cyclingTrack')} />
            <p>{t('amenities.cyclingTrack')}</p>
          </div>
          <div className='colum_list'>
            <img src="/assets/Iconos/Amenidades/svg-icon-coworking.svg" alt={t('amenities.coworking')} />
            <p>{t('amenities.coworking')}</p>
          </div>
          <div className='colum_list'>
            <img src="/assets/Iconos/Amenidades/svg-icon-area-verde.svg" alt={t('amenities.greenArea')} />
            <p>{t('amenities.greenArea')}</p>
          </div>
          <div className='colum_list'>
            <img src="/assets/Iconos/Amenidades/svg-icon-padel.svg" alt={t('amenities.padelCourt')} />
            <p>{t('amenities.padelCourt')}</p>
          </div>
          <div className='colum_list'>
            <img src="/assets/Iconos/Amenidades/svg-icon-acceso.svg" alt={t('amenities.dualAccess')} />
            <p>{t('amenities.dualAccess')}</p>
          </div>
          <div className='colum_list'>
            <img src="/assets/Iconos/Amenidades/svg-icon-picnics.svg" alt={t('amenities.picnicArea')} />
            <p>{t('amenities.picnicArea')}</p>
          </div>
        </div>
      </div>
      <div id="galeria" className='amenidades_bottom'>
        <Slider nav={false} pag={true}>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider">
              <img src="./assets/amenidades/img-velasur-casa-club.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider">
              <img src="./assets/amenidades/img-velasur-ciclovia.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider">
              <img src="./assets/amenidades/img-velasur-lago.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider">
              <img src="./assets/amenidades/img-velasur-padel.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__amenidades_carousel__slider">
              <img src="./assets/amenidades/img-velasur-picnics.jpg" alt="Velasur" />
            </div>
          </SwiperSlide>
        </Slider>
      </div>
    </div>
  );
}
 
export default Amenidades;
